const constants = {
    ADD_ITEM: "ADD_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    INCREMENT_ITEM_AMOUT: "INCREMENT_ITEM_AMOUT",
    REDUCE_ITEM_AMOUT: "REDUCE_ITEM_AMOUT",
    ADD_TO_SELECT_ITEM:"ADD_TO_SELECT_ITEM",
    REMOVE_FROM_SELECT_ITEM:"REMOVE_FROM_SELECT_ITEM",
}

export default constants



// WEBPACK FOOTER //
// ./public_html/_/components/js/constants.js